import { ModalBackground, ModalCard } from "../linktab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useRef, useState } from "react";
import file from "../../../assets/images/Image File.png";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { addproductlink } from "../../../validations/addproductlink";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../../constants";
import { Heading, ImageContainer, Image, Input, Important } from "./styles";

interface PaymentProps {
  toggleClear: () => void;
  getLink: () => void;
}

type FormData = yup.InferType<typeof addproductlink>;
export function AddLinkModal({ toggleClear, getLink }: PaymentProps) {
  const [isloading, setisloading] = useState(false);
  const imageRef = useRef<any>();
  let businessUuid = useSelector((state: any) => state.auth.uuid);
  const [imageSize, setImageSize] = useState({
    message: "",
  });
  let [linkForm, setlinkForm] = useState<any>({});
  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(addproductlink),
  });
  const { errors, isSubmitting, isDirty, isValid } = formState;

  const previewImage = (event: any) => {
    event.preventDefault();
    let reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        imageRef.current.src = reader.result;
        setlinkForm({ ...linkForm, image: event.target.files[0] });
      }
    };
    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const createProductRequest = async (data: any) => {
    setisloading(true);
    if (linkForm?.image === null) {
      setImageSize({
        message: "Image required ",
      });
      setisloading(false);
      return;
    } else if (linkForm?.image?.size >= 5000000) {
      setImageSize({
        message: "File is too large, Max allowed size is 5MB",
      });
      setisloading(false);
      return;
    } else {
      setImageSize({
        message: "",
      });

      let formData = new FormData();
      if (linkForm?.image?.name) {
        formData.append("image", linkForm.image, linkForm.image?.name);
      }

      const testUrl = /https?:\/\//i.test(data.url); // Check for "http" or "https"

      if (testUrl) {
        formData.append("url", data.url);
      } else {
        formData.append("url", `https://${data.url}`);
      }

      formData.append("name", data.name);
      formData.append("isImportant", data.important);
      formData.append("businessUuid", businessUuid);
      console.log(formData);

      axios
        .post(`${API_URL}/create/link`, formData)
        .then((response) => {
          reset();
          setlinkForm({ name: null, image: null });
          if (response.status === 200 || response.status === 201) {
            toggleClear();
            setisloading(false);
            toast.success(response.data.message);
            setlinkForm({});
            getLink();
          }
        })
        .catch((error) => {
          setisloading(false);
          setlinkForm({});

          if (
            error?.response?.status === 400 ||
            error?.response?.status === 401
          ) {
            toast.error(error?.response?.data?.message);
            return;
          }
          toast.error("Connection Failed");
        });
    }
  };
  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>Add Link</Heading>
          <form onSubmit={handleSubmit(createProductRequest)}>
            <ImageContainer>
              <Image>
                <img
                  src={linkForm?.image?.imageUrl || file}
                  alt=""
                  ref={imageRef}
                />
                <input
                  className="h-[100%] w-[100%] opacity-0  cursor-pointer absolute top-0 left-0 z-50 "
                  type="file"
                  {...register("fileUpload")}
                  onChange={previewImage}
                  accept="image/*"
                />
              </Image>
            </ImageContainer>
            {imageSize?.message && (
              <p className="text-xs mb-2 text-red-600">{imageSize?.message}</p>
            )}
            <Input type="text" placeholder="Name" {...register("name")} />
            {errors?.name && (
              <p className="text-xs mb-2 text-red-600">
                {errors.name?.message}
              </p>
            )}
            <Input type="text" placeholder="https://" {...register("url")} />
            {errors?.url && (
              <p className="text-xs mb-2 text-red-600">{errors.url?.message}</p>
            )}
            <Important>
              <p>Tag as Important</p>
              <input type="checkbox" id="check" {...register("important")} />
              <label htmlFor="check" className="button"></label>
            </Important>
            <SubmitButton
              isDisabled={isSubmitting || !isDirty || !isValid}
              isloading={isloading}
              value="Save"
              width="19.6em"
            />
          </form>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}
